import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import connect from "react-redux/es/connect/connect";
import "./LoginStyles.scss";
import { Role } from "../../../constants/role";
import auth from "../../restricted/auth";
import { login } from "../../../store/auth/authActions";
import LoginView from "./LoginView";
import {
  HOME,
  USER_MANAGEMENT,
  ADMIN_PANEL_USER_MANAGEMENT,
  YOUTUBE_MANAGEMENT,
  INSTAGRAM_MANAGEMENT,
  NOTIFICATION_MANAGEMENT,
  BANNER_MANAGEMENT,
} from "../../../navigation/routes";
import { history } from "../../../store/configure/configureStore";
import { trimFormData } from "../../../utils/common";
import * as validator from "../../../utils/validator";

export class LoginContainer extends Component {
  // constructor(props) {
  //   super(props);
  // } dev branch

  state = {
    fields: {
      name: "",
      password: "",
      remember: "",
      email: "",
    },
    errors: {},
  };

  componentDidUpdate() {}

  componentDidMount() {}

  componentWillUnmount() {}

  handleChange = ({ target }) => {
    const field = target.name;
    this.setState({
      fields: { ...this.state.fields, [field]: target.value },
      errors: {},
    });
  };

  renderEmailErrorMessage = () => {
    // if email address already in use then show error in form
    const formMailErrorMessage = { email: "email address already in use" };
    this.setState({ ...this.state, errors: formMailErrorMessage });
  };

  onLogin = () => {
    var fields = this.state.fields;

    const validatorFields = {
      required: ["email", "password"],
      custom: [validator.email(["email"]), validator.password(["password"])],
    };

    const { errors } = validator.validate(
      validatorFields,
      // trimFormData(fields)
      fields
    );
    this.setState({ ...this.state, errors });
    var fields = this.state.fields;
    if (!Object.keys(errors).length) {
      this.props.login(fields.email, fields.password, () => {
        this.renderEmailErrorMessage();
      });
    }
  };

  render() {
    // console.log("Hello Tested");
    if (auth.isAuthenticated()) {
      // console.log("Authenticated!", auth, auth.isAuthenticated());

      const userRole = this.props.loginUser?.data?.roleId[0].role;

      switch (userRole) {
        case Role.Administrator:
          console.log("Administrator");
          history.push(ADMIN_PANEL_USER_MANAGEMENT);
          break;
        case Role.Editor:
          console.log("Editor");
          // history.push(USER_MANAGEMENT);
          history.push(YOUTUBE_MANAGEMENT);
          // history.push(NOTIFICATION_MANAGEMENT);
          // history.push(BANNER_MANAGEMENT);
          break;
        case Role.Moderator:
          console.log("moderator");
          history.push(YOUTUBE_MANAGEMENT);
          // history.push(NOTIFICATION_MANAGEMENT);
          break;
        case Role.Viewer:
          console.log("Viewer");
          history.push(YOUTUBE_MANAGEMENT);
          // history.push(NOTIFICATION_MANAGEMENT);
          break;
        default:
          return null;
      }
    }
    return (
      <>
        <LoginView
          onLogin={this.onLogin}
          fields={this.state.fields}
          onChange={this.handleChange}
          isLoader={this.props.isLoader}
          errors={this.state.errors}
        />
      </>
    );
  }
}

LoginContainer.propTypes = {
  login: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  authSuccess: state.auth.authSuccess,
  authData: state.auth,

  isLoader: state.loader.isOpen,
  loginUser: state.auth.loginUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      login: login,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
